"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _DrawerWrapper = _interopRequireDefault(require("./DrawerWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// export this package's api
var _default = _DrawerWrapper.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-drawer/lib/index.js
// module id = 1950
// module chunks = 0